export const GET_BUSINESS_CLINIC_LIST = "GET_BUSINESS_CLINIC_LIST"